import { render, staticRenderFns } from "./SearchingAnAPI.vue?vue&type=template&id=f8c1cb80&"
import script from "./SearchingAnAPI.vue?vue&type=script&lang=js&"
export * from "./SearchingAnAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports